import { AxiosResponse } from "axios";
import { http } from "../../../../src/utils";

export type InvoiceFont = 'FONT_1' | 'FONT_2'
export type FontSizeDeviation = 1 | 0.5 | 0 | -0.5 | -1

export interface ConfigProperties {
  outwardChallanPrefix?: string
  inwardChallanPrefix?: string
  invoiceNoPrefix?: string
  /** Allowed digit widths for invoice number sequence, e.g. 4 → 0001 */
  invoiceNoLength?: number
  saleInvoiceNoPrefix?: string
  /** Allowed digit widths for sale invoice number sequence */
  saleInvoiceNoLength?: number
  /** Allowed digit widths for challan number sequence */
  challanNoLength?: number
  upiId?: string
  upiId2?: string
  sgst?: number
  cgst?: number
  /** Optional iron rate per kg */
  ironRate?: number
  selectedFont?: InvoiceFont
  fontSizeDeviation?: FontSizeDeviation
}

export interface StoreTncs {
  id?: number
  quotationTnc?: string
  bankAccountDetails?: string
  agreementTnc?: string
  challanTnc?: string
  invoiceTnc?: string
  saleInvoiceTnc?: string
  invoiceTitle?: string
  nonGstBankAccount?: string
  challanFormat?: string
  configProperties?: ConfigProperties
}

export function saveStoreTnc(
  storeTncs: StoreTncs
) {
  let url = `/store_tnc/pvt`
  return http
    .post(
      url,
      storeTncs
    )
    .then((response: AxiosResponse) => response.data)
}

export function getStoreTnc() {
  let url = `/store_tnc/pvt`
  return http
    .get(
      url    
    )
    .then((response: AxiosResponse) => response.data)
}